// Design tokens for the "Red Reinventa Tu Vida" brand skin.
// Source of truth: design_handoff_metodo_vaena_quiz/README.md
export const colors = {
  teal: "#0f3a4a",
  tealBorder: "#1c5b70",
  coral: "#e8623a",
  coralHover: "#cf4f28",
  cream: "#f6f3ec",
  coolBg: "#eef4f2",
  body: "#16323d",
  muted: "#4d6570",
  faint: "#93a5ac",
  borderLight: "#e3ecee",
  borderInput: "#d9e2e4",
  borderFaint: "#eef1f2",
  borderCream: "#eee7d9",
  selectedTint: "#fdf1ec",
  featureSwatchCoral: "#fbe6dd",
  featureSwatchTeal: "#d9e8ea",
  radioIdle: "#c7d3d6",
  resultBodyOnDark: "#c3d3d8",
  // Results screen — coral variant (design_handoff_metodo_vaena-2_quiz)
  resultsBg: "#fdf1ec",
  resultsIntroText: "#fde3d8",
  resultsDivider: "#f0c4ae",
  resultsDetailText: "#7a4638",
};

export const fonts = {
  heading: "'Poppins', sans-serif",
  body: "'Inter', sans-serif",
};

export const shadows = {
  card: "0 12px 32px rgba(15,58,74,0.08)",
  insightCard: "0 8px 24px rgba(15,58,74,0.06)",
};

export const radii = {
  pill: 999,
  card: "16px",
  insightCard: "14px",
  option: "12px",
  input: "10px",
  swatch: "6px",
};

// Pantallas chicas (celulares) en las que las tarjetas con scroll interno
// (landing, quiz, resultados) usan un max-height más chico para quedar más
// compactas. Se define acá para no repetir el mismo media query en cada
// componente.
export const compactCardBreakpoint = "@media (max-width: 400px) and (max-height: 900px)";

// Pantallas bajas de CUALQUIER ancho (a diferencia de compactCardBreakpoint,
// que solo cubre celulares angostos): tablets/desktops con poca altura
// también necesitan que la tarjeta sea más chica para no quedar tapada por
// lo que sigue después del iframe en el sitio que embebe la app.
export const shortViewportBreakpoint = "@media (max-height: 730px)";
